import { createSlice } from "@reduxjs/toolkit";
import {
  getTaxSettings,
  patchTaxSetting,
  postTaxSetting,
  deleteTaxSetting,
  getTaxesEnabled,
  patchTaxesEnabled,
} from "./taxSettingsActions";

const initialState = {
  loading: false,
  error: null,
  success: false,
  taxes: [],
  // [CANA-591] "Enable Taxes" from taxes/settings/. null = not known yet.
  taxesEnabled: {
    loading: false,
    error: null,
    isEnabled: null,
  },
};

const taxSettingsSlice = createSlice({
  name: "taxSettings",
  initialState,
  reducers: {
    resetTaxesError: (state) => {
      state.error = null;
      state.postError = null

    },
    resetShopSettingError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTaxSettings.pending, (state) => {
        state.loading = true;
        // [CANA-589] a 403 from an earlier load must not outlive a reload.
        state.error = null;
      })
      .addCase(getTaxSettings.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.taxes = payload;
      })
      .addCase(getTaxSettings.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(postTaxSetting.pending, (state) => {
        state.loading = true;
      })
      .addCase(postTaxSetting.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.taxes = [payload, ...state?.taxes];
      })
      .addCase(postTaxSetting.rejected, (state, { payload }) => {
        state.loading = false;
        state.postError = payload;
      })
      .addCase(patchTaxSetting.pending, (state) => {
        state.loading = true;
      })
      .addCase(patchTaxSetting.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.taxes = state?.taxes?.map((tax) =>
          tax?.id?.toString() === payload?.id?.toString() ? payload : tax
        );
      })
      .addCase(patchTaxSetting.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(deleteTaxSetting.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTaxSetting.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.taxes = state?.taxes?.filter(
          (tax) => tax?.id?.toString() !== payload?.id?.toString()
        );
      })
      .addCase(deleteTaxSetting.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getTaxesEnabled.pending, (state) => {
        state.taxesEnabled.loading = true;
        state.taxesEnabled.error = null;
      })
      .addCase(getTaxesEnabled.fulfilled, (state, { payload }) => {
        state.taxesEnabled.loading = false;
        state.taxesEnabled.isEnabled = payload?.is_taxes_enabled ?? null;
      })
      .addCase(getTaxesEnabled.rejected, (state, { payload }) => {
        state.taxesEnabled.loading = false;
        state.taxesEnabled.error = payload;
      })
      .addCase(patchTaxesEnabled.pending, (state) => {
        state.taxesEnabled.loading = true;
        state.taxesEnabled.error = null;
      })
      .addCase(patchTaxesEnabled.fulfilled, (state, { payload }) => {
        state.taxesEnabled.loading = false;
        state.taxesEnabled.isEnabled = payload?.is_taxes_enabled ?? null;
      })
      .addCase(patchTaxesEnabled.rejected, (state, { payload }) => {
        state.taxesEnabled.loading = false;
        state.taxesEnabled.error = payload;
      });
  },
});
export const { resetShopSettingError, resetTaxesError } = taxSettingsSlice.actions;
export default taxSettingsSlice.reducer;
